import axios from 'axios'
import {baseUrl} from './env'
import store from '../store'
import {Loading, Notification} from 'element-ui'
import router from '../../router'

// 创建axios实例 application/x-www-data-urlencoded application/json
// const service = axios.create({
//   baseURL: '',
//   timeout: 15000,
//   headers: {'Content-Type': 'application/json'}
// })

// service.interceptors.response.use(
//   function (response) {
//     // 请求正常则返回（所有的请求头和请求体信息）
//     return Promise.resolve(response)
//   },
//   function (error) {
//     const httpError = {
//       alertFlat: true,
//       errorStatus: error.response.status,
//       msgg: error.response.statusText
//     }
//     this.$store.commit('SET_ALERT_FLAG', {state: false, type: 'ok'})
//     console.log(httpError)
//     return Promise.reject(error)
//   }
// )

let loadinginstace
// 请求时的拦截器
axios.interceptors.request.use(
  config => {
    // 发送请求之前的一些处理，如loading
    loadinginstace = Loading.service({fullscreen: true, text: '正在加载中'})
    if (store.state && store.state.token) {
      config.headers.Authorization = store.state.token
    }
    config.headers.post['Content-Type'] = 'application/json'
    return config
  },
  error => {
    loadinginstace.close()
    Notification.error({
      message: '加载超时',
      position: 'bottom-right'
    })
    // 请求异常时的处理
    return Promise.reject(error)
  })

axios.interceptors.response.use(
  response => {
    // 返回响应的处理，response是个对象
    // {
    //      data: { },        // 服务器提供的响应
    //      status: 200,      // 服务器响应的HTTP状态代码
    //      statusText: 'OK', // 服务器响应的HTTP状态消息
    //      headers: {},      // 服务器响应头
    //      config: {}        // axios 的配置
    // }
    let data
    // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
    if (response && response.data !== undefined) {
      data = response.data
    } else if (response && response.request !== undefined) {
      data = response.request.responseText
    } else if (response){
      data = response
    }
    loadinginstace.close()
    return data
  },
  error => {
    // 当响应异常时的处理
    // 这里已将错误信息扶正，后面不需catch
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          break

        case 401:
          error.message = '未授权，请登录'
          break

        case 403:
          error.message = '拒绝访问，请重新登录！'
          store.commit('SET_TOKEN', '')
          store.commit('SET_USERINFO', '')
          store.commit('SET_ACCOUNT', '')
          store.commit('SET_PERMISSION', '')
          store.commit('SET_ORGINFO', '')
          store.commit('SET_SHPINFO', '')
          router.replace({
            path: 'login',
            query: {redirect: router.currentRoute.fullPath}
          })
          break

        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`
          break

        case 408:
          error.message = '请求超时'
          break

        case 500:
          error.message = '服务器内部错误'
          break

        case 501:
          error.message = '服务未实现'
          break

        case 502:
          error.message = '网关错误'
          break

        case 503:
          error.message = '服务不可用'
          break

        case 504:
          error.message = '网关超时'
          break

        case 505:
          error.message = 'HTTP版本不受支持'
          break

        default:
      }
    }
    loadinginstace.close()

    if (error.message.indexOf("ERROR_LOGIN_SESSION_IS_NULL") == -1) {
      Notification.error({
        message: '操作失败：' + error.message,
        position: 'bottom-right'
      })
    } else {
      store.commit('SET_TOKEN', '')
      store.commit('SET_USERINFO', '')
      store.commit('SET_ACCOUNT', '')
      store.commit('SET_PERMISSION', '')
      store.commit('SET_ORGINFO', '')
      store.commit('SET_SHPINFO', '')
      router.replace({
        path: 'login',
        query: {redirect: router.currentRoute.fullPath}
      })
      Notification.error({
        message: '请重新登录！',
        position: 'bottom-right'
      })
    }

    // 此处我使用的是 element UI 的提示组件
    return Promise.reject(error) // 返回接口返回的错误信息
  }
)

function errorState(response) {
  // .. 隐藏loading
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
    return response
  } else {
    console.log('网络异常')
  }
}

function successState(res) {
}

const httpServer = (opts, data) => {
  // 公共参数
  let Public = {}
  // http默认配置
  let httpDefaultOpts = {
    method: opts.method, // 请求协议
    baseURL: baseUrl, // 基础URL前缀
    url: opts.url,
    timeout: opts.timeout || 60000, // 单位毫秒
    headers: opts.method === 'get' ? {
      'X-Reqyested-With': 'XMLHttpRequest',
      'Accept': 'application/json',
      'Content-Type': 'application/json; charset=UTF-8'
    } : {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json; charset=UTF-8'
      // 'Content-Type' : 'application/x-www-form-urlencoded; charset=YTF-8' application/x-www-form-urlencoded或multipart/form-data或text/plain
    },
    params: Object.assign(Public, data), // get请求时带的参数
    // POST请求参数，qs.stringify数据处理，主要配合headers里的Content-Type
    data: JSON.stringify(Object.assign(Public, data))
  }

  if (opts.method === 'get') {
    delete httpDefaultOpts.data
  } else {
    delete httpDefaultOpts.params
  }

  let promise = new Promise(function (resolve, reject) {
    axios(httpDefaultOpts).then((res) => {
      if (res && res.resultType === 'Success') {
        if (opts.sucMsg) {
          Notification.success({
            message: '操作成功！',
            type: 'success',
            position: 'bottom-right',
            duration: 2000
          })
        }
        resolve(res)
      } else {
        if (res) {
          if (res.resultMessage.indexOf("ERROR_LOGIN_SESSION_IS_NULL") == -1) {
            Notification.error({
              message: '操作失败：' + res.resultMessage,
              position: 'bottom-right'
            })
          } else {
            Notification.error({
              message: '请重新登录！',
              position: 'bottom-right'
            })
            store.commit('SET_TOKEN', '')
            store.commit('SET_USERINFO', '')
            store.commit('SET_ACCOUNT', '')
            store.commit('SET_PERMISSION', '')
            store.commit('SET_ORGINFO', '')
            store.commit('SET_SHPINFO', '')
            router.replace({
              path: 'login',
              query: {redirect: router.currentRoute.fullPath}
            })
          }
        } else {
          Notification.error({
            message: '操作失败，请刷新后重试！',
            position: 'bottom-right'
          })
        }
      }

    }).catch((response) => {
      // errorState(response)
      reject(response)
    })
  })
  return promise
}

export default httpServer
